'use client';
import { useState, useEffect } from 'react';

export function PartnerLink() {
  const [href] = useState('#');

  useEffect(() => {
    // fetch('/api/integration/get-environment-variables')
    //   .then((r) => r.json())
    //   .then((res) => {
    //     if (res?.PartnerLoginUrl) setHref(res.PartnerLoginUrl);
    //   })
    //   .catch(() => {});
  }, []);

  return (
    <a href={href} id="ibcs6" link-type="url" target="_blank" className="PartnerLoginUrl">
      Partner Login
    </a>
  );
}
